import { createReducer } from "redux-act";

import {
  REQNotificationDetail,
  RESNotificationDetail,
  SAVExNotification,
  SAVEDxNotification,
  PREVIEWxAudience,
  RESPreviewAudience,
  FailNotificationDetail,
  CleanUpNotificationDetail
} from "./actions";

const initialState = {
  REQStrNotificationDetail: false,
  Saving: false,
  Notification: null,
  Saved: false,
  EstimatedReach: null,
  errorMessage: false
};

const notificationDetailReducer = createReducer(
  {
    [REQNotificationDetail]: state => {
      return {
        ...state,
        REQStrNotificationDetail: true,
        errorMessage: false
      };
    },

    [RESNotificationDetail]: (state, payload) => {
      return {
        ...state,
        REQStrNotificationDetail: false,
        Notification: payload,
        errorMessage: false
      };
    },

    [SAVExNotification]: state => {
      return {
        ...state,
        Saving: true,
        Saved: false,
        errorMessage: false
      };
    },

    [SAVEDxNotification]: (state, payload) => {
      return {
        ...state,
        Saving: false,
        Saved: true,
        Notification: payload,
        errorMessage: false
      };
    },

    [PREVIEWxAudience]: state => {
      return {
        ...state,
        EstimatedReach: null
      };
    },

    [RESPreviewAudience]: (state, payload) => {
      return {
        ...state,
        EstimatedReach: payload.estimatedReach
      };
    },

    [FailNotificationDetail]: (state, payload) => {
      return {
        ...state,
        REQStrNotificationDetail: false,
        Saving: false,
        errorMessage: (payload && payload.message) || "บันทึกการแจ้งเตือนไม่สำเร็จ"
      };
    },

    [CleanUpNotificationDetail]: () => {
      return initialState;
    }
  },

  initialState
);

export default notificationDetailReducer;
